import React from 'react';
import { shape, string, bool } from 'prop-types';
import ListPanel from 'ps-components/ListPanel/ListPanel';

import './OrgJobInfo.scss';

const withJobCodeKeyColumns = [
  {
    dataKey: 'title',
    title: 'Company Job',
    field_type_code: 'text'
  },
  {
    dataKey: 'code',
    title: 'Job Code',
    field_type_code: 'text'
  },
  {
    dataKey: 'codeKey',
    title: 'Job Code Key',
    field_type_code: 'text'
  },
  {
    dataKey: 'currency',
    title: 'Currency',
    field_type_code: 'text'
  }
];

const withoutJobCodeKeyColumns = [
  {
    dataKey: 'title',
    title: 'Company Job',
    field_type_code: 'text'
  },
  {
    dataKey: 'code',
    title: 'Job Code',
    field_type_code: 'text'
  },
  {
    dataKey: 'currency',
    title: 'Currency',
    field_type_code: 'text'
  }
];

class OrgJobInfo extends React.Component {
  static propTypes = {
    selectedOrgJob: shape({
      code: string,
      codeKey: string,
      id: string,
      title: string,
      currency: string
    }),
    hideJobCodeKey: bool,
    jobCodeKeyText: string
  };

  getColumns() {
    const { hideJobCodeKey, jobCodeKeyText } = this.props;

    if (hideJobCodeKey) {
      return withoutJobCodeKeyColumns;
    }

    // Replace title with sysconfig for job code key
    withJobCodeKeyColumns[2].title = jobCodeKeyText;

    return withJobCodeKeyColumns;
  }

  render() {
    const { selectedOrgJob } = this.props;

    const columns = this.getColumns();

    return (
      <ListPanel
        className="overall-composites__org-job-info"
        items={[
          {
            ...selectedOrgJob
          }
        ]}
        columns={columns}
        idProp="id"
        hideTableHeader={true}
        hideCheckBox={true}
        expandedMaxColumnCount={1}
      />
    );
  }
}

export default OrgJobInfo;
